import React, { useContext, useCallback, useMemo, useEffect, useState } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useModal } from '@jutro/components';
import { withRouter } from 'react-router-dom';
import styles from '../../../SpaAndWellCommonStyles.module.scss';
import metadata from './MassageTherapists.metadata.json5';
import messages from './MassageTherapists.messages';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function MassageTherapists(props) {

    // const { submissionVM, pathUpdated, updateWizardData } = props;
    const {
        submissionVM,
        updateWizardData,
        pathUpdated,
        index
    } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('MassageTherapists');
    const modelVM = _.get(submissionVM, pathUpdated)
    const { showConfirm } = useModal();

    modelVM.value.isValidationReq = true

    const initializeMessageTherapists = () => {
        const yeaofEduFieValue = _.get(modelVM, 'yeaofEduFie.value') !== undefined
            ? _.get(modelVM, 'yeaofEduFie.value') : 0;
        const yeaofExpFieValue = _.get(modelVM, 'yeaofExpFie.value') !== undefined
            ? _.get(modelVM, 'yeaofExpFie.value') : 0;
        const areYouanRMTFieValue = _.get(modelVM, 'areYouanRMTFie.value') !== undefined
            ? _.get(modelVM, 'areYouanRMTFie.value') : "false";
        const doyoucolanddisthecinfFieValue = _.get(modelVM, 'doyoucolanddisthecinfFie.value') !== undefined
            ? _.get(modelVM, 'doyoucolanddisthecinfFie.value') : "true";
        const howlontoyoukeeclihyeaFieValue = _.get(modelVM, 'howlontoyoukeeclihyeaFie.value') !== undefined
            ? _.get(modelVM, 'howlontoyoukeeclihyeaFie.value') : 1;
        const isawaisigdatandkeprecFieValue = _.get(modelVM, 'isawaisigdatandkeprecFie.value') !== undefined
            ? _.get(modelVM, 'isawaisigdatandkeprecFie.value') : "true";
        const doyouoffmastoinfFieValue = _.get(modelVM, 'doyouoffmastoinfFie.value') !== undefined
            ? _.get(modelVM, 'doyouoffmastoinfFie.value') : "false";
        const ifyeshowmanyeaFieValue = _.get(modelVM, 'ifyeshowmanyeaFie.value') !== undefined
            ? _.get(modelVM, 'ifyeshowmanyeaFie.value') : 1;


        _.set(modelVM, 'yeaofEduFie.value', yeaofEduFieValue);
        _.set(modelVM, 'yeaofExpFie.value', yeaofExpFieValue);
        _.set(modelVM, 'areYouanRMTFie.value', areYouanRMTFieValue);
        _.set(modelVM, 'doyoucolanddisthecinfFie.value', doyoucolanddisthecinfFieValue);
        _.set(modelVM, 'howlontoyoukeeclihyeaFie.value', howlontoyoukeeclihyeaFieValue);
        _.set(modelVM, 'isawaisigdatandkeprecFie.value', isawaisigdatandkeprecFieValue);
        _.set(modelVM, 'doyouoffmastoinfFie.value', doyouoffmastoinfFieValue);
        _.set(modelVM, 'ifyeshowmanyeaFie.value', ifyeshowmanyeaFieValue);
    }

    useEffect(() => {
        initializeMessageTherapists();
    }, []);

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    const deleteMassageTherapist = useCallback(
        () => {
            const infoListPath = 'lobData.spaAndWellLine.coverables.beauticiansSpa.massage.pswmasRisk.value';
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifyeshowmanyeaFie: {
            visible: _.get(modelVM, 'isawaisigdatandkeprecFie.value') !== undefined && _.get(modelVM, 'isawaisigdatandkeprecFie.value'),
            defaultValue: 1
        },
        areYouanRMTFie: {
            defaultValue: false
        },
        doyoucolanddisthecinfFie: {
            defaultValue: true
        },
        howlontoyoukeeclihyeaFie: {
            defaultValue: 1
        },
        isawaisigdatandkeprecFie: {
            defaultValue: true
        },
        doyouoffmastoinfFie: {
             defaultValue: false
        },
        massageTherapistsHeading: {
            visible: false
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            deleteMassageTherapist
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );

}

MassageTherapists.propTypes = wizardProps;
export default withRouter(MassageTherapists);
